var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home justify-content-center p-30"},[_c('van-empty',{attrs:{"image":"network","description":"Нет подключение к интернету"}}),_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.refreshApp}},[_vm._v("Обновить")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }